/** Canonical origin. Every prerendered page needs absolute URLs for canonical, Open Graph and the feed. */
export const SITE = 'https://timato.app';

/**
 * The blog's root, and the shape every blog URL takes: no trailing slash.
 * Cloudflare Pages serves `blog/x/index.html` at `/blog/x` and redirects `/blog/x/` to it, so a canonical
 * link, a sitemap entry or a feed item written with the slash costs every crawler a redirect hop.
 */
export const BLOG = '/blog';

/** The legal documents are static pages beside the blog, built from `content/pages` by the same pipeline. */
export const PRIVACY = '/privacy';
export const TERMS = '/terms';
/** The site described for AI assistants (TW-64): a static file, linked with a plain `<a>` like the legal pages. */
export const LLMS = '/llms.txt';

export const postPath = (slug: string) => `${BLOG}/${slug}`;
export const tagPath = (tag: string) => `${BLOG}/tag/${tag.toLowerCase()}`;
export const absolute = (path: string) => `${SITE}${path}`;
